import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { BCLedgerTotalRequestDto } from "../models/bcLedgers/bcLedgerTotalRequestDto";
import { BCLedgerTotalResponseDto } from "../models/bcLedgers/bcLedgerTotalResponseDto";
import { CommissionProgramTierRequestDto } from "../models/bcLedgers/commissionProgramTierRequestDto";
import { CommissionProgramTierResponseDto } from "../models/bcLedgers/commissionProgramTierResponseDto";
import { YtdSummaryRequestDto } from "../models/bcLedgers/ytdSummaryRequestDto";
import { YtdSummaryResponseDto } from "../models/bcLedgers/ytdSummaryResponseDto";
import { GenericResponseDto } from "../models/generic-response.dto";
import { Employee } from "../models/profile/employee";
import { BcRevenueTransactionsResponseDto } from "../models/bcLedgers/BcRevenueTransactionsResponseDto";
import { ChargeBackRequestDto } from "../models/bcLedgers/chargeBackRequestDto";
import { AdjustmentsRequestDto } from "../models/bcLedgers/adjustmentsRequestDto";
import { CommissionPaidTotalRequestDto } from "../models/bcLedgers/commissionPaidTotalRequestDto";
import { CommissionPaidTotalResponseDto } from "../models/bcLedgers/commissionPaidTotalResponseDto";
import { YtdBacklogRequest } from "../models/bcLedgers/ytdbacklog/YtdBacklogRequest";
import { YtdBacklogResponse } from "../models/bcLedgers/ytdbacklog/YtdBacklogResponse";
import { FreightsRequestDto } from "../models/bcLedgers/freightsRequestDto";
import { FreightsResponseDto } from "../models/bcLedgers/freightsResponseDto";
import { GetSalesOrderIdRequestDto } from "../models/bcLedgers/getSalesOrderIdRequestDto";
import { GetSalesOrderIdResponseDto } from "../models/bcLedgers/getSalesOrderIdResponseDto";
import { GetTrackingDetailsRequestDto } from "../models/bcLedgers/getTrackingDetailsRequestDto";
import { GetTrackingDetailsResponseDto } from "../models/bcLedgers/getTrackingDetailsResponseDto";
import { GPAdjustmentRequestDto } from "../models/bcLedgers/gpAdjustmentRequestDto";
import { GPAdjustmentResponseDto } from "../models/bcLedgers/gpAdjustmentResponseDto";
import { MiscRequestDto } from "../models/bcLedgers/misc/MiscRequestDto";
import { MiscResponseDto } from "../models/bcLedgers/misc/MiscResponseDto";
import { MoveToFreightRequestDto } from "../models/bcLedgers/moveToFreightRequestDto";
import { MoveToFreightResponseDto } from "../models/bcLedgers/moveToFreightResponseDto";
import { NetChargesRequestDto } from "../models/bcLedgers/netChargesRequestDto";
import { SalesCommissionRequestDto } from "../models/bcLedgers/salesCommissionRequestDto";
import { SampleRequestDto } from "../models/bcLedgers/sample/SampleRequestDto";
import { SampleResponseDto } from "../models/bcLedgers/sample/SampleResponseDto";
import { TotalApMiscRequestDto } from "../models/bcLedgers/totalApMiscRequestDto";
import { TotalApMiscResponseDto } from "../models/bcLedgers/totalApMiscResponseDto";
import { YtdgpRequestDto } from "../models/bcLedgers/ytdgpRequestDto";
import { TypeDto } from "../models/bcLedgers/typeDto";

@Injectable({
  providedIn: "root",
})
export class BcledgerService {
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";
  private bcLedgerBaseURL = environment.baseUrl + "/bcledger";
  private commonBaseURL = environment.baseUrl + "/Common";
  constructor(private _http: HttpClient) {}

  getTypeList(): Observable<GenericResponseDto<TypeDto[]>> {
    return this._http.get<GenericResponseDto<TypeDto[]>>(
      this.clientManagementBaseURL + "/GetAllClientType"
    );
  }

  bcLedgerTotal(
    payload: BCLedgerTotalRequestDto
  ): Observable<GenericResponseDto<BCLedgerTotalResponseDto>> {
    return this._http.post<GenericResponseDto<BCLedgerTotalResponseDto>>(
      `${this.bcLedgerBaseURL}/BCLedgerTotal`,
      payload
    );
  }

  ytdSummary(
    payload: YtdSummaryRequestDto
  ): Observable<GenericResponseDto<YtdSummaryResponseDto>> {
    return this._http.post<GenericResponseDto<YtdSummaryResponseDto>>(
      `${this.bcLedgerBaseURL}/YtdSummary`,
      payload
    );
  }

  commissionProgramTier(
    payload: CommissionProgramTierRequestDto
  ): Observable<GenericResponseDto<CommissionProgramTierResponseDto>> {
    return this._http.post<
      GenericResponseDto<CommissionProgramTierResponseDto>
    >(`${this.bcLedgerBaseURL}/CommissionProgramTier`, payload);
  }

  getAllEmployees(): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllEmployees`
    );
  }

  getAllEmployeesForOrderBillingReport(): Observable<
    GenericResponseDto<Employee[]>
  > {
    return this._http.get<GenericResponseDto<Employee[]>>(
      `${this.commonBaseURL}/GetAllEmployeesForOrderBillingReport`
    );
  }

  chargeBack(
    payload: ChargeBackRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/ChargeBack`, payload);
  }

  getBacklogDetailsData(
    payload: YtdBacklogRequest
  ): Observable<GenericResponseDto<YtdBacklogResponse>> {
    return this._http.post<GenericResponseDto<YtdBacklogResponse>>(
      `${this.bcLedgerBaseURL}/YTDBacklog`,
      payload
    );
  }

  adjustments(
    payload: AdjustmentsRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/Adjustments`, payload);
  }

  commissionPaidTotal(
    payload: CommissionPaidTotalRequestDto
  ): Observable<GenericResponseDto<CommissionPaidTotalResponseDto>> {
    return this._http.post<GenericResponseDto<CommissionPaidTotalResponseDto>>(
      `${this.bcLedgerBaseURL}/CommissionPaidTotal`,
      payload
    );
  }

  getTrackingDetailData(
    payload: GetTrackingDetailsRequestDto
  ): Observable<GenericResponseDto<GetTrackingDetailsResponseDto>> {
    return this._http.post<GenericResponseDto<GetTrackingDetailsResponseDto>>(
      `${this.bcLedgerBaseURL}/GetTrackingDetails`,
      payload
    );
  }

  freights(
    payload: FreightsRequestDto
  ): Observable<GenericResponseDto<FreightsResponseDto>> {
    return this._http.post<GenericResponseDto<FreightsResponseDto>>(
      `${this.bcLedgerBaseURL}/Freights`,
      payload
    );
  }

  gpAdjustments(
    payload: GPAdjustmentRequestDto
  ): Observable<GenericResponseDto<GPAdjustmentResponseDto>> {
    return this._http.post<GenericResponseDto<GPAdjustmentResponseDto>>(
      `${this.bcLedgerBaseURL}/GPAdjustment`,
      payload
    );
  }

  getMiscData(
    payload: MiscRequestDto
  ): Observable<GenericResponseDto<MiscResponseDto>> {
    return this._http.post<GenericResponseDto<MiscResponseDto>>(
      `${this.bcLedgerBaseURL}/Misc`,
      payload
    );
  }

  getSalesOrderID(
    payload: GetSalesOrderIdRequestDto
  ): Observable<GenericResponseDto<GetSalesOrderIdResponseDto>> {
    return this._http.post<GenericResponseDto<GetSalesOrderIdResponseDto>>(
      `${this.bcLedgerBaseURL}/GetSalesOrderID`,
      payload
    );
  }

  moveToFreight(
    payload: MoveToFreightRequestDto
  ): Observable<GenericResponseDto<MoveToFreightResponseDto>> {
    return this._http.post<GenericResponseDto<MoveToFreightResponseDto>>(
      `${this.bcLedgerBaseURL}/MoveToFreight`,
      payload
    );
  }

  netCharges(
    payload: NetChargesRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/NetCharges`, payload);
  }

  salesCommission(
    payload: SalesCommissionRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/SalesCommission`, payload);
  }

  getSampleData(
    payload: SampleRequestDto
  ): Observable<GenericResponseDto<SampleResponseDto>> {
    return this._http.post<GenericResponseDto<SampleResponseDto>>(
      `${this.bcLedgerBaseURL}/Sample`,
      payload
    );
  }

  getTotalApMisc(
    payload: TotalApMiscRequestDto
  ): Observable<GenericResponseDto<TotalApMiscResponseDto>> {
    return this._http.post<GenericResponseDto<TotalApMiscResponseDto>>(
      `${this.bcLedgerBaseURL}/TotalApMisc`,
      payload
    );
  }

  totalSalesCommissionsAdjustments(
    payload: SalesCommissionRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/TotalSalesCommissionsAdjustments`, payload);
  }

  ytdgp(
    payload: YtdgpRequestDto
  ): Observable<GenericResponseDto<BcRevenueTransactionsResponseDto>> {
    return this._http.post<
      GenericResponseDto<BcRevenueTransactionsResponseDto>
    >(`${this.bcLedgerBaseURL}/YTDGP`, payload);
  }
}
